import { Outlet } from 'react-router-dom';
import Header from './Header';

const Layout = ({
  autenticazione,
  temaColori,
  mobile
}) => {

  return (
    <div className={temaColori}>
      <Header autenticazione={autenticazione}  temaColori={temaColori} mobile={mobile}/>
      <div className={mobile? "content f7 f6-l contentSubHeader" : "content f7 f6-l"}>
        <Outlet />
      </div>
    </div>
  );
};

export default Layout;